import { useMemo } from "react";
import useResponsiveValues from "@/components/editor/hooks/useResponsiveValues";
import { DimentionTypes } from "@/components/dimention-field/DimentionField";
import { BorderRadius } from "./BorderRadiusSettings";

const PROPS: (keyof BorderRadius)[] = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomRightRadius",
  "borderBottomLeftRadius",
];

const useNormalizeBorderRadius = (props: BorderRadius) => {
  const responsive = useResponsiveValues();

  const draft = useMemo(() => {
    const draft: BorderRadius = {};

    PROPS.forEach((prop) => {
      if (props[prop]) {
        const value = responsive.getValue(props[prop]);
        draft[prop] = value ? value + DimentionTypes.PIXELS : undefined;
      }
    });

    return draft;
  }, [props, responsive]);
  return draft;
};

export default useNormalizeBorderRadius;
